
// import { useState } from "react";
// import { toast } from "react-toastify";
// import { addUserApi } from "../../apis/userApi";

// export const useAddUser = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const addUser = async (formData) => {
//     setLoading(true);
//     setError(null);

//     const toastId = toast.loading("Creating new user...");

//     try {
//       const newUser = await addUserApi(formData);

//       toast.update(toastId, {
//         render: "User created successfully!",
//         type: "success",
//         isLoading: false,
//         autoClose: 3000,
//       });

//       return newUser;
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.data ||
//         err.response?.data?.detail ||
//         err.data ||
//         "Failed to create user. Please check the form.";

//       toast.update(toastId, {
//         render: errorMessage,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });

//       setError(errorMessage);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { addUser, loading, error };
// };

import { useState } from "react";
import { toast } from "react-toastify";
import { addUserApi } from "../../apis/userApi";

export const useAddUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
    // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to create user.",
    };
  };

  const addUser = async (formData) => {
    setLoading(true);
    setError(null);

    const toastId = toast.loading("Creating new user...");

    try {
      const newUser = await addUserApi(formData);

      toast.update(toastId, {
        render: (
          <div>
            <strong>User Created</strong>
            <div>User created successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      return newUser;
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError({ title, issue });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { addUser, loading, error };
};